import { JourneyLocalStorage, TeamType, useAnchorLocalStorage } from '@/utils/local-storage-hook';

import { SupportedGupsTeamTypes } from './use-gups';

export const useAnchorLocalStorageTeamType = () => {
	const { getAnchorLocalStorage } = useAnchorLocalStorage();
	const anchorLocalStorage = getAnchorLocalStorage();
	if (anchorLocalStorage) {
		try {
			const localStorageObj: JourneyLocalStorage = JSON.parse(anchorLocalStorage);
			return normalizeTeamType(localStorageObj.team);
		} catch (e) {
			return undefined;
		}
	}

	return undefined;
};

export const normalizeTeamType = (
	teamType: TeamType | undefined,
): SupportedGupsTeamTypes | undefined => {
	switch (teamType) {
		case 'Marketing':
			return 'marketing';
		case 'Operations':
			return 'operations';
		case 'HR':
			return 'human-resources';
		case 'Design':
			return 'design';
		case 'Program Management':
			return undefined;
		case 'Software Engineering':
			return 'software-engineering';
		case 'Customer Service':
			return 'customer-service';
		case 'Legal':
			return 'legal';
		case 'Finance':
			return `finance`;
		case 'Sales':
			return 'sales';
		case 'IT Support':
			return 'it-support';
		case 'Software Development':
			return 'software-development';
		default:
			return undefined;
	}
};
